import {
  BoardIds,
  FilterIdentifier,
  FilterUserSelection,
} from "../../common/generic/generic-filters-boards-attributes";
import { BuildClient360Url } from "../../common/generic/generic-helper";
import { NbiDimensions } from "../../common/generic/generic-nbi-dimensions";
import {
  IGenericAggregateResponse,
  IGenericHyperlinkFilter,
} from "../../common/generic/generic-types";
import { AgFormat } from "../../common/utils/agGridFormat";
import { Format } from "../../common/utils/format";
import {
  ICprGbisSearchCriteria,
  IHeaders,
  INbiKpi,
  INbiResponse,
} from "../../common/utils/types";
import {
  IYtdDealTops,
  IYtdLeTops,
  IYtdNbiTopOutput,
  IYtdSalesTops,
} from "./types";

export function mapData(
  salesData: IGenericAggregateResponse,
  dealData: IGenericAggregateResponse,
  leData: IGenericAggregateResponse
): IYtdNbiTopOutput {
  const dimensions = new NbiDimensions();
  const topDeals: IYtdDealTops[] = [];
  let dealCount: number = 1;
  for (const deal of dealData.aggregates ? dealData.aggregates : []) {
    topDeals.push({
      Date: AgFormat.AgGridFormatDate(
        deal.dimensionAttributeValues[dimensions.GBIS_CREDIT_DATE]
      ),
      Id: dealCount,
      LEFullName: deal.dimensionAttributeValues[dimensions.CLIENT_LENAME],
      ProductLevel3: deal.dimensionAttributeValues[dimensions.PRODUCT_LEVEL3],
      SalesName: deal.dimensionAttributeValues[dimensions.SALESBEN_SALES],
      Ytd: Format.FormatMoney(deal.indicatorKpiValues.nbi_ytd, 1000, 0),
    });
    dealCount++;
  }
  const topSales: IYtdSalesTops[] = [];
  let salesCount: number = 1;
  for (const item of salesData.aggregates ? salesData.aggregates : []) {
    topSales.push({
      Id: salesCount,
      SalesName: item.dimensionAttributeValues[dimensions.SALESBEN_SALES],
      SubSubBL: item.dimensionAttributeValues[dimensions.FPV_SSBL],
      Ytd: Format.FormatMoney(item.indicatorKpiValues.nbi_ytd, 1000, 0),
    });
    salesCount++;
  }

  const topLe: IYtdLeTops[] = [];
  let leCount: number = 1;
  const dateForFilter = [];
  dateForFilter.push(leData.request ? leData.request.date : "");
  for (const item of leData.aggregates ? leData.aggregates : []) {
    if (item.dimensionAttributeValues !== undefined) {
      const clientId = item.dimensionAttributeValues[dimensions.CLIENT_LEID];
      const clientIdForFilter = [];
      clientIdForFilter.push(clientId);

      const hfilterType: any = [];
      hfilterType.push({
        filter_id: FilterIdentifier.client_selector,
        id: FilterUserSelection.client_selector,
        value: clientIdForFilter,
      });
      hfilterType.push({
        filter_id: FilterIdentifier.asOfDate,
        id: FilterUserSelection.asOfDate,
        value: dateForFilter,
      });

      const hFilter: IGenericHyperlinkFilter = {
        board_id: BoardIds.Client_Card,
        filter: hfilterType,
      };
      topLe.push({
        ClientId: clientId,
        Id: leCount,
        LEFullName: item.dimensionAttributeValues[dimensions.CLIENT_LENAME],
        Ytd: Format.FormatMoney(item.indicatorKpiValues.nbi_ytd, 1000, 0),
        hlink: BuildClient360Url(clientId),
      });
      leCount++;
    }
  }
  const ytdNbiTopOutput: IYtdNbiTopOutput = {
    TopDeals: topDeals,
    TopLegalEntities: topLe,
    TopSales: topSales,
  };
  return ytdNbiTopOutput;
}
